<template>
    <div class="file-upload d-flex flex-column align-items-center">
        <div class="mb-4">
            <input
                :id="`file{$id}`"
                :accept="accept"
                type="file"
                @change="handleFileSelection"
            >
            <label
                ref="label"
                :for="`file{$id}`"
                class="btn btn-secondary"
            >
                <SVGSprite
                    name="upload"
                    class="upload-icon mr-3"
                />
                {{ label }}
            </label>
            <button
                v-if="isFileImage && !isEditorVisible"
                type="button"
                class="btn btn-primary"
                @click="editImage"
            >
                Edit Image
            </button>
            <button
                v-if="isFileImage && isEditorVisible"
                type="button"
                class="btn btn-primary"
                @click="saveImage"
            >
                Save Image
            </button>
        </div>
        <img
            v-if="isFileImage && !isEditorVisible && previewImage"
            class="preview-image"
            :src="previewImage"
        >
        <ImageEditor
            v-if="isFileImage && isEditorVisible && image.file"
            ref="imageEditor"
            :src="image.file"
            :type="image.mime"
            class="image-editor"
            @save="imageFromEditor"
        />
        <div
            v-if="(file || image.file) && filename"
            class="d-flex flex-column align-items-center"
        >
            <div class="p-3">
                <strong>{{ filename }}</strong> selected
            </div>
            <button
                type="button"
                class="btn btn--secondary"
                :disabled="isEditorVisible"
                @click="upload"
            >
                Upload
            </button>
        </div>
    </div>
</template>

<script>
import ImageEditor from './ImageEditor/components/Container';

export default {
    name: 'FileUpload',
    components: {
        ImageEditor
    },
    props: {
        label: {
            type: String,
            default: 'Select file to upload'
        },
        extensions: {
            type: Array,
            required: true
        },
        mimes: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            file: null,
            filename: null,
            id: null,
            isFileImage: false,
            isEditorVisible: false,
            imageMimes: [
                'image/jpeg',
                'image/png',
                'image/gif'
            ],
            image: {
                file: null,
                mime: null
            },
            editedImage: null
        };
    },
    computed: {
        accept() {
            return [this.extensions.join(','), this.mimes.join(',')].join(',');
        },
        previewImage() {
            const previewImage = this.editedImage || this.image.file || false;
            return previewImage instanceof Blob ? this.createObjectURL(previewImage) : previewImage;
        }
    },
    beforeMount() {
        this.id = this._uid;
    },
    methods: {
        createObjectURL(obj) {
            const urlCreator = window.URL || window.webkitURL;
            return this.editedImage && urlCreator.createObjectURL(obj);
        },
        handleFileSelection(event) {
            const file = event.target.files[0];

            if (file) {
                const reader = new FileReader();

                reader.onloadend = () => {
                    this.file = file;

                    if (this.imageMimes.indexOf(file.type) >= 0) {
                        this.image.file = reader.result;
                        this.image.mime = file.type;
                        this.isFileImage = true;
                    }
                    else {
                        this.isFileImage = false;
                        this.image.file = this.image.mime = null;
                    }
                    this.$emit('file', {
                        file: this.file,
                        name: file.name
                    });
                    this.filename = file.name;
                };

                reader.readAsDataURL(file);
            }
            else {
                this.file = this.image.file = this.image.mime = this.editedImage = this.filename = null;
                this.isFileImage = false;
                this.$emit('file', null);
            }
        },
        editImage() {
            if (this.editedImage) {
                this.image.file = this.createObjectURL(this.editedImage);
            }
            this.isEditorVisible = true;
        },
        saveImage() {
            this.$refs.imageEditor.save();
        },
        imageFromEditor(blob) {
            this.editedImage = blob;
            this.isEditorVisible = false;
            this.$emit('file', {
                file: blob,
                name: this.file.name
            });
        },
        upload() {
            this.$emit('upload');
        },
        reset() {
            this.file = this.filename = this.id = this.image.file = this.image.mime = this.editedImage = null;
            this.isFileImage = this.isEditorVisible = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.image-editor {
    min-height: 500px;
    max-height: 50vh;
    max-width: 100%;
}

.upload-icon {
    width: 20px;
    height: 20px;
}

input[type=file] {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;

    + label {
        margin-bottom: 0;
    }
}

.preview-image {
    max-width: 100%;
    height: auto;
}
</style>
